import React from 'react'
import { FormGroup } from 'react-bootstrap'
import { Form, EmailBox } from 'fw/forms'
import { Button } from 'fw/components'
import { Link } from 'react-router-dom'
import Completed from 'layouts/public/completed/Completed'
import * as API from 'modules/app/API'
import * as Notifications from 'fw/globals/Notifications'

class ResetPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => {
        return {
            error: null,
            completed: false,
            form: {
                email: ""
            }
        }
    }

    resetPassword = (e) => {
        const rq = {
            email: this.state.form.email
        }

        this.setState({ error: null }, function () {
            API.Security.post('/recovery/resetPassword', rq,
                {
                    success: (sr) => {
                        this.setState({ completed: true });
                    },
                    error: (sr) => {
                         Notifications.error(sr.error.errorMessage);
                    }
                });
        });
    }

    onChange = (form) => {
        this.setState({ form });
    }

    render() {
        if (this.state.completed) {
            return (<Completed
                title="Reset password has been processed."
                message="A reset link has been sent to the email address on file for this account." />)
        }

        return (
            <React.Fragment>
                <p className="login-box-heading">Password Recovery</p>
                <p>To request a password reset, please enter the email address associated with your account:</p>
                <Form
                    onSubmit={this.resetPassword}
                    values={this.state.form}
                    onChange={this.onChange}>
                    <FormGroup>
                        <EmailBox name="email" autoFocus={true} placeholder="Email" required />
                    </FormGroup>
                    <FormGroup className="text-center">
                        <Button id="btnRequest" type="submit" bsClass="btn btn-primary btn-flat">Request!</Button>
                    </FormGroup>
                    <div className="login-box-links">
						<Link className="pull-right" to="/public/login">Go back to login</Link>
                    </div>
                </Form>
            </React.Fragment>
        );
    }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/areas/public/resetPassword/ResetPassword.js